<template>
  <label class="skin-profile-form-input">
    <span class="skin-profile-form-input__label">{{ label }}:</span>
    <input
      class="skin-profile-form-input__input"
      :value="modelValue"
      @input="onInputMessage($event.target.value)"
      v-bind="$attrs"
    />
  </label>
</template>

<script>
export default {
  name: "SkinProfileFormInput",
  inheritAttrs: false,

  props: {
    modelValue: String,
    label: {
      type: String,
      default: "Label"
    }
  },

  methods: {
    onInputMessage(value) {
      this.$emit("update:modelValue", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.skin-profile-form-input {
  display: block;
  text-align: left;
  margin-bottom: 0.5rem;
}

.skin-profile-form-input__label {
  display: block;
  font-weight: 700;
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
}

.skin-profile-form-input__input {
  display: block;
  font-size: 1rem;
  width: 100%;
  padding: 5px 5px;
  border-radius: 4px;
  border: 1px solid silver;
}
</style>
